// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-checkbox-row {
  margin-bottom: 8px;
}

.skl-field-grid {
  display: grid;
  grid-template-columns: minmax(0, 320px);
  gap: 20px;
}

.skl-field-hint {
  display: block;
  margin-top: 8px;
}

.skl-actions {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/cmdb-sync/cmdb-sync-settings-skeleton/cmdb-sync-settings-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uCAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".skl-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-checkbox-row {\n  margin-bottom: 8px;\n}\n\n.skl-field-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 320px);\n  gap: 20px;\n}\n\n.skl-field-hint {\n  display: block;\n  margin-top: 8px;\n}\n\n.skl-actions {\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
